import type { RealtimeEventName, RealtimeEvents } from '@mc/shared/realtime';

import type { QueryKey } from '@tanstack/react-query';

/**
 * Qué consultas vuelve a pedir la web ante cada evento (docs/03 › Web, docs/05 §11). Las claves
 * de módulos que todavía no existen (agenda, caja…) quedan listas para cuando lleguen.
 */
export type InvalidatingEvent = Exclude<RealtimeEventName, 'session.revoked'>;

export const INVALIDATIONS: { [E in InvalidatingEvent]: (p: RealtimeEvents[E]) => QueryKey[] } = {
  'appointment.created': (p) => [['appointments', p.branchId], ['my-day']],
  'appointment.updated': (p) => [['appointments', p.branchId], ['my-day']],
  'appointment.status_changed': (p) => [['appointments'], ['appointment', p.id], ['my-day']],
  'schedule_block.changed': (p) => [
    ['appointments', p.branchId],
    ['schedule-blocks', p.branchId],
  ],
  'ledger.entry_created': (p) => [['statement', p.patientId], ['cash-sessions'], ['my-day']],
  'ledger.entry_voided': (p) => [['statement', p.patientId], ['cash-sessions'], ['my-day']],
  'cash_session.updated': (p) => [['cash-sessions', p.branchId]],
  'patient.updated': (p) => [['patient', p.id], ['patients'], ['intake-forms']],
  'note.signed': (p) => [['patient', p.patientId, 'notes'], ['patient', p.patientId, 'timeline'], ['my-day']],
  'whatsapp.reply': (p) => [['appointment', p.appointmentId], ['appointments'], ['my-day'], ['whatsapp']],
  'job.updated': (p) => [['jobs'], ['job', p.id]],
  'daily_plan.changed': () => [['my-day']],
  'stock.below_min': () => [['inventory']],
  'branch.changed': () => [['branches']],
};
